import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/config/routes';
import { isPlatformAdmin } from '@/host/access';
import { EmailView } from '@/platform/orgs/EmailView';

export const Route = createFileRoute('/_app/platform-email')({
   beforeLoad: ({ context }) => {
      if (!isPlatformAdmin(context.user)) throw redirect({ to: ROUTES.HOME, replace: true });
   },
   component: () => <EmailView scope="platform" />
});
